import { AdunitImageUploadIconOn, AdunitImageUploadIconOff } from "@icons";
import { AppState, ImageAssetAttribute, UploadFileForAssetAction, VideoAssetAttribute } from "@store";
import * as cn from "classnames";
import { FieldInfo } from "rd-redux-forms";
import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { AssetAttributeFormMeta } from "../../../store/adunit-builder/adUnitAssetBuilderForm";
import { LoadingSpinner } from "../../LoadingSpinner";
import { SvgIcon } from "../../SvgIcon";
import "./FileUploader.css";
import { parseUrlForFileName } from "@common";

let inputCounter = 1;

interface FileUploaderComponentProps {
    value: string;
    fileTypes?: string[];
    uploadingInputId: string | undefined;
    onUrlChanged: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFileSelected?: (e: React.ChangeEvent<HTMLInputElement>, inputId: string) => void;
}

export interface FileUploaderComponentState {
    hoveredItem: number;
}

class FileUploaderComponent extends React.Component<FileUploaderComponentProps, FileUploaderComponentState> {
    constructor(props: FileUploaderComponentProps) {
        super(props);
        this.state = {
            hoveredItem: null
        };
    }

    mouseEnter(id: number) {
        this.setState({
            hoveredItem: id
        });
    }

    mouseLeave() {
        this.setState({
            hoveredItem: null
        });
    }

    private inputId = `FileUploader${++inputCounter}`;

    render() {
        const { value, uploadingInputId, fileTypes, onUrlChanged, onFileSelected } = this.props;
        const accept = fileTypes && fileTypes.length ? fileTypes.join(",") : undefined;
        const isUploading = uploadingInputId === this.inputId;
        const { hoveredItem } = this.state;

        return (
            <div className="FileUploader">
                <input
                    value={parseUrlForFileName(value) || ""}
                    className="FileUploader__url important"
                    onChange={onUrlChanged}
                    type="text"
                    disabled={true}
                />
                <label className={cn("FileUploader__file-selector", { uploading: isUploading })}>
                    <input
                        className="FileUploader__file-input"
                        accept={accept}
                        type="file"
                        onChange={e => onFileSelected(e, this.inputId)}
                        disabled={!!uploadingInputId}
                    />
                    <span
                        onMouseEnter={e => this.mouseEnter(1)}
                        onMouseLeave={e => this.mouseLeave()}
                        className="FileUploader__file-selector-label"
                    >
                        <SvgIcon
                            className="info-list_svg"
                            svg={hoveredItem === 1 ? AdunitImageUploadIconOn : AdunitImageUploadIconOff}
                        />
                    </span>
                </label>
                <span className={cn("FileUploader__loader-indicator", { uploading: isUploading })}>
                    <LoadingSpinner />
                </span>
            </div>
        );
    }
}

export interface FileUploaderProps {
    asset: ImageAssetAttribute | VideoAssetAttribute;
    meta: AssetAttributeFormMeta;
    fieldName: string;
    field: FieldInfo;
    fieldEvents: any;
}

const assetTypeMimePrefix = {
    image: "image/",
    video: "video/"
};

export const FileUploader = connect(
    (appState: AppState, ownProps: FileUploaderProps): Partial<FileUploaderComponentProps> => {
        const { asset, field, fieldEvents } = ownProps;
        return {
            value: (field && field.value) || "",
            fileTypes: asset.formats
                ? asset.formats
                      .map(f => {
                          const mimeTypePrefix = assetTypeMimePrefix[asset.type];

                          if (!mimeTypePrefix) {
                              return undefined;
                          }

                          return `${mimeTypePrefix}${f.toLowerCase()}`;
                      })
                      .filter(f => !!f)
                : undefined,
            onUrlChanged: e => fieldEvents.onChange(e.currentTarget.value),
            uploadingInputId: appState.adUnitBuilder.uploadingFileId
        };
    },
    (dispatch: Dispatch, { fieldName, meta }: FileUploaderProps): Partial<FileUploaderComponentProps> => ({
        onFileSelected(e: React.ChangeEvent<HTMLInputElement>, inputId: string) {
            if (e.currentTarget.files && e.currentTarget.files.length) {
                dispatch(
                    UploadFileForAssetAction({
                        file: e.currentTarget.files[0],
                        fieldName,
                        meta,
                        uploadingFileId: inputId
                    })
                );
            }
            // dispatch();
        }
    })
)(FileUploaderComponent);
